import React, { PropTypes } from 'react'
import { Translate, consts, utils } from 'unity-core'
import { connect } from 'react-redux'
const { Routes } = consts
const { stringUtils } = utils
import * as loader from 'loader'

import path from 'assets/dnb_full_logo.png'

const propTypes = {
  modules: PropTypes.object,
  selectedModule: PropTypes.string,
  strings: PropTypes.object.isRequired
}
const defaultProps = {
  modules: {}
}

const Footer = ({ strings, selectedModule, modules }) => {
  let text = 'Unity'
  let module = _.find(modules, x => x.path == selectedModule)
  if (module) {
    text = module.name
    let res = loader.loadModule(module.bundle)
    if (res) text = res.getDesc()
  }
  return (
    <div className="dnb-global-footer dnb-global-footer-product col-sm-12 col-xs-12">
      <div className="product-name">
        <img src={path} />
        <span className="prod-name">{text}</span>
      </div>
      <div className="company-info">
        <ul className="legal">
          <li className="copyright"><span dangerouslySetInnerHTML={{ __html: stringUtils.format(strings.Copyright, moment.utc().year()) }} /></li>
          <li><a href="http://www.dnb.com/utility-pages/privacy-policy.html" target="_blank">{strings.PrivacyPolicy}</a></li>
          <li><a href="http://www.dnb.com/utility-pages/terms-of-use.html" target="_blank">{strings.Terms}</a></li>
        </ul>
      </div>
    </div>
  )
}

Footer.propTypes = propTypes
Footer.defaultProps = defaultProps

const mapStateToProps = (store) => ({
  modules: store.app.modules,
  selectedModule: store.user.selectedModule
})

const decorators = _.flow([
  connect(mapStateToProps),
  Translate('Footer')
])

export default decorators(Footer)
